<template>
  <div id="app">
    <NavBar v-if="navbar"/>
    <router-view :class="{'app-content': navbar}" />
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue';

export default {
  components: {
    NavBar,
  },
  data() {
    return {
      navbar: true,
    };
  },
  watch: {
    '$route.name': {
      handler(name) {
        if (name === 'login' || name === 'notfound' || name === 'forget') {
          this.navbar = false;
        } else {
          this.navbar = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .app-content {
    margin-top: 3rem;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
